// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6f0c9c3f","36":"5f980514","333":"1814cd46","449":"55d147b0","470":"af9955dc","548":"5019c93d","681":"50cf68b0","712":"242611b5","722":"f320624f","779":"dc1d7c5e","787":"f83b9b5c"}[chunkId] + ".chunk.js";
};